import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className="flex items-center space-x-2">
            <button
                onClick={toggleTheme}
                className="relative inline-flex items-center h-6 w-12 rounded-full transition-colors duration-300 focus:outline-none"
                style={{
                    backgroundColor: isDark ? '#1a1a1a' : '#e5e5e5'
                }}
                aria-label="Toggle theme"
            >
                {/* The sliding circle */}
                <span
                    className="inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out"
                    style={{
                        transform: isDark ? 'translateX(28px)' : 'translateX(4px)'
                    }}
                />
            </button>

            {/* Icon to the right */}
            <span className="text-sm" style={{ color: isDark ? '#ffffff' : '#1a1a1a' }}>
                {isDark ? '☾' : '☀'}
            </span>
        </div>
    );
};

export default ThemeToggle;
